<div class="api-keys-container">
  <ng-template #noRead>
    <app-authorized-guard
      [authorized]="false"
      message="You are not authorized to view this data"
    ></app-authorized-guard>
  </ng-template>
  <mat-card-content *hasPrivilege="'tenant_api_key/read'; else noRead">
    <div class="table-wrapper">
      <app-loading-guard [loading]="entityList && entityList.loading">
        <app-portal
          name="organization-actions"
          *hasPrivilege="'tenant_api_key/create'"
        >
          <button
            class="new-api-key"
            mat-raised-button
            [routerLink]="['/organization', 'apikeys', 'create']"
            color="accent"
          >
            New API Key
          </button>
        </app-portal>

        <app-authorized-guard [authorized]="!unauthorized">
          <mat-table
            id="api-keys-table"
            class="kahi-table"
            [dataSource]="entityList.entities"
          >
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{ item.name }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{ getTypeName(item.type) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let item">
                <div class="actions">
                  <button mat-icon-button (click)="getDetails(item)">
                    <mat-icon> open_in_full </mat-icon>
                  </button>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              class="row"
              *matRowDef="let row; columns: displayedColumns"
            ></mat-row>
          </mat-table>
        </app-authorized-guard>

        <mat-paginator
          [length]="entityList.total"
          [pageIndex]="entityList.page - 1"
          [pageSize]="entityList.perPage"
          [pageSizeOptions]="[20, 50, 100]"
          (page)="onPageEvent($event)"
        ></mat-paginator>
      </app-loading-guard></div
  ></mat-card-content>
</div>
